import DownIcon from './component'

export default DownIcon
